import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('shared_business_rule', '/shared_business_rules')
const actions = generator.generate()

export default actions
